import './publicDemo';
import './config/amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { createPublicHeaderUpdater } from './utils/publicHeader';

const header = document.querySelector('.site-header');
if (header) {
  const refresh = createPublicHeaderUpdater(header, fetchAuthSession, process.env.VUE_APP_DOCS_URL);
  refresh();
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });
  window.addEventListener('storage', event => {
    if (event.key === null || event.key.startsWith('CognitoIdentityServiceProvider.')) refresh();
  });
}
